import type { StorageAdapter } from '@splitfiesta/core';

/**
 * Browser localStorage implementation of StorageAdapter.
 *
 * Wrapped in try/catch to tolerate environments where localStorage is
 * unavailable or quota-exceeded (private mode, Safari ITP, etc.). Failures
 * silently fall back to no-op for set/remove and null for get.
 */
export const webStorage: StorageAdapter = {
  async getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* ignore quota / unavailable */
    }
  },
  async removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
